'use client'

import { useSession } from 'next-auth/react'
import Navbar from './Navbar'

export default function PromoNavClient() {
  const { data, status } = useSession()
  const isLogin =
    status === 'authenticated' && Boolean(data?.access_token)

  return (
    <>
      <Navbar isLogin={isLogin} />
    </>
  )
}
